import React, { useEffect, useState } from 'react';
import { ListStyled, MailMessageListItem, MailMessageListItemButton, MailMessageListItemTextBox, MailMessagesList, MailMessagesListBox, MailNavListItem, MailNavListItemButton } from './style';
import { Box, Drawer, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { AttachFile } from '@mui/icons-material';
import MailMessageDetails from './MailMessageDetails';
import { CustomChip } from '../../components/CustomChip';
import FilterByCompany from '../../components/FilterByCompany';
import ShowAddedCompanyBox from '../../components/ShowAddedCompanyBox';
import DrawerHeaderBox from '../../components/DrawerHeaderBox';
import { LABEL_CONSTANTS, MAIL_NAV_LIST } from '../../contants/mailPageConstants';
import { useLocation, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import NoDataPresentUI from '../../components/NoDataPresentUI';
import BlankIcon from '../../icons/BlankIcon';

import { readMailAsync } from './mailSlice';
import { useDispatch } from 'react-redux';
import { CompanyBadge } from '../../components/CompanyBadge';
import { ParaText } from '../../style/GlobalStyles';

function MailMessagesListBoxUI({ mailMessageAllDataList, setMailMessageAllDataList, selectedNavItem, setSelectedNavItem, userDetails }) {
    const [currentMailMessageList, setCurrentMailMessageList] = useState([]);
    const [currentMailMessageOriginalList, setCurrentMailMessageOriginalList] = useState([...mailMessageAllDataList]);
    const [selectedMailItem, setSelectedMailItem] = useState(null);
    const [selectedCompanyList, setSelectedCompanyList] = useState([]);
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);

    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    const selectedItemDetails = {
        mailId: searchParams.get('mailId'),
        filterId: searchParams.get('filterId'),
        filterByCompanyIds: searchParams.getAll('filter'),
    };

    const toggleDrawer = (newOpen) => setOpen(newOpen);

    const handleBack = () => {
        setSelectedMailItem(null);
        toggleDrawer(false);

        const newParams = new URLSearchParams(location.search);
        newParams.delete('mailId');
        // newParams.delete('filterId');
        navigate(`${location.pathname}?${newParams.toString()}`);
    };

    const handleCompanyFilterChange = (selectedCompanyIds) => setSelectedCompanyList(selectedCompanyIds);

    // We are currently not using handleSnoozed, handleDelete, handleStarred, handlePrint. It is added earlier then removed.
    const handleSnoozed = () => {
        const updatedList = mailMessageAllDataList.map((cItem) => {
            if (cItem.id === selectedMailItem.id) {
                return {
                    ...cItem,
                    relatedTo: selectedMailItem.relatedTo === LABEL_CONSTANTS.Snoozed ? LABEL_CONSTANTS.Inbox : LABEL_CONSTANTS.Snoozed,
                };
            }
            return cItem;
        });

        setMailMessageAllDataList(updatedList);
    };

    const updateAllMail = (record) => {
        const updatedList = mailMessageAllDataList.map((cItem) => {
            if (cItem.id === record.id) {
                return {
                    ...record,
                };
            }
            return cItem;
        });

        setMailMessageAllDataList(updatedList);
        setSelectedMailItem(record);
    };
    const handleDelete = () => {
        const updatedList = mailMessageAllDataList.map((cItem) => {
            if (cItem.id === selectedMailItem.id) {
                return {
                    ...cItem,
                    relatedTo: selectedMailItem.relatedTo === LABEL_CONSTANTS.Delete ? LABEL_CONSTANTS.Inbox : LABEL_CONSTANTS.Delete,
                };
            }
            return cItem;
        });

        setMailMessageAllDataList(updatedList);
    };
    const handleStarred = () => {
        const updatedList = mailMessageAllDataList.map((cItem) => {
            if (cItem.id === selectedMailItem.id) {
                return {
                    ...cItem,
                    relatedTo: selectedMailItem.relatedTo === LABEL_CONSTANTS.Starred ? LABEL_CONSTANTS.Inbox : LABEL_CONSTANTS.Starred,
                };
            }
            return cItem;
        });

        setMailMessageAllDataList(updatedList);
    };
    function handlePrint(elementId) {
        // const printContent = document.getElementById(elementId);
        // const windowPrint = window.open("", "", "width=800,height=600");
        // windowPrint.document.write("<html><head><title>Print</title>");
        // windowPrint.document.write("</head><body >");
        // windowPrint.document.write(printContent.innerHTML);
        // windowPrint.document.write("</body></html>");
        // windowPrint.document.close();
        // windowPrint.focus();
        // windowPrint.print();
        // windowPrint.close();
    }

    const handleMailListSelection = (cListItem, selectedNavItemId) => {
        setSelectedMailItem(cListItem);
        if (!cListItem.read) {
            dispatch(readMailAsync({ mailId: cListItem.id }));
        }
        const newParams = new URLSearchParams(location.search);
        if (String(newParams.get('mailId')) !== String(cListItem.id)) {
            newParams.set('mailId', cListItem.id);
        }
        if (!selectedNavItemId && String(newParams.get('filterId')) !== String(selectedNavItem.id)) {
            newParams.set('filterId', selectedNavItem.id);
        }
        if (selectedNavItemId && String(newParams.get('filterId')) !== String(selectedNavItemId)) {
            newParams.set('filterId', selectedNavItemId);
        }
        navigate(`/mail?${newParams.toString()}`);
    };

    const handleNavSelection = (cMailNav) => {
        setSelectedNavItem(cMailNav);

        // let newMailMessageList = [...mailMessageAllDataList];
        // const newSelectedNavItem = MAIL_NAV_LIST?.find((cItem) => {
        //     return String(cItem.id) === String(cMailNav.id);
        // });
        // const newList = mailMessageAllDataList?.filter((cItem) => {
        //     return newSelectedNavItem.filter(cItem);
        // });
        // if (selectedItemDetails.filterByCompanyIds?.length) {
        //     newMailMessageList = newList.filter((cItem) => {
        //         return selectedItemDetails.filterByCompanyIds.find((id) => String(id) === String(cItem.companyId));
        //     });
        // } else {
        //     newMailMessageList = newList;
        // }

        const newParams = new URLSearchParams(location.search);
        // if (!isMobileView && String(newParams.get('mailId')) !== String(newMailMessageList[0]?.id)) {
        //     newParams.set('mailId', newMailMessageList[0]?.id);
        // }
        newParams.delete('mailId');
        if (String(newParams.get('filterId')) !== String(cMailNav.id)) {
            newParams.set('filterId', cMailNav.id);
        }
        navigate(`/mail?${newParams.toString()}`);
    };

    useEffect(() => {
        let newSelectedNavItem = getNevList()[0];
        let newMailMessageList = [...mailMessageAllDataList];
        let newList = [];

        if (selectedItemDetails.filterId) {
            newSelectedNavItem = getNevList()?.find((cItem) => {
                return String(cItem.id) === String(selectedItemDetails.filterId);
            });
        }

        if (newSelectedNavItem) {
            // get mails list related to that
            newList = mailMessageAllDataList?.filter((cItem) => {
                return newSelectedNavItem.filter(cItem);
            });
        }

        if (selectedItemDetails.filterByCompanyIds?.length) {
            newMailMessageList = newList.filter((cItem) => {
                return selectedItemDetails.filterByCompanyIds.find((id) => String(id) === String(cItem.companyId));
            });
        } else {
            newMailMessageList = newList;
        }

        setSelectedNavItem(newSelectedNavItem);

        setCurrentMailMessageList(newMailMessageList);

        // get selected mail item using params
        // if mailId not present
        // elseif mailId present but not exist(matched) in db
        // else if mailId present and matched then
        // not present in filtered list then set first mail in filtered list
        // else no mail
        if (selectedItemDetails.mailId && newMailMessageList.length > 0) {
            // here params exist
            let selectedMailItem = newMailMessageList?.find((cItem) => {
                return String(cItem.id) === String(selectedItemDetails.mailId);
            });
            // if (!selectedMailItem) {
            //     selectedMailItem = mailMessageAllDataList?.find((cItem) => {
            //         return String(cItem.id) === String(selectedItemDetails.mailId);
            //     });
            //     selectedMailItem = selectedMailItem ? handleMailListSelection(newMailMessageList[0]) : null;
            // }

            setSelectedMailItem(selectedMailItem ? selectedMailItem : null);
            if (selectedMailItem?.read === false) {
                dispatch(readMailAsync({ mailId: selectedMailItem.id }));
            }
            selectedMailItem ? toggleDrawer(true) : toggleDrawer(false);

            // if (!selectedMailItem) {
            //     handleMailListSelection(newMailMessageList[0]);
            // } else {
            //     setSelectedMailItem(selectedMailItem);
            //     if (selectedMailItem?.read === false) {
            //         dispatch(readMailAsync({ mailId: selectedMailItem.id }));
            //     }
            //     //dispatch(readMailAsync({ mailId: selectedMailItem.id }));
            //     selectedMailItem ? toggleDrawer(true) : toggleDrawer(false);
            // }
        } else {
            // params do not exist
            // if (!isMobileView && newMailMessageList.length > 0) {
            //     handleMailListSelection(newMailMessageList[0], !selectedItemDetails.filterId ? '1' : '');
            // } else {
            //     setSelectedMailItem(null);
            // }

            setSelectedMailItem(null);
        }

        // mailMessageAllDataList  it can be removed from this file if remove delete,snooze
    }, [location.search, mailMessageAllDataList, isMobileView]);

    console.log('selectedMailItem, currentMailMessageList: ', selectedMailItem, currentMailMessageList);

    // useEffect(() => {
    //     if (!selectedMailItem && !isMobileView && currentMailMessageList.length > 0) {
    //         //setSelectedMailItem(currentMailMessageList[0]);
    //         setTimeout(() => {
    //             dispatch(readMailAsync({ mailId: currentMailMessageList[0].id }));
    //         }, 1000);

    //         toggleDrawer(true);
    //     }
    // }, [currentMailMessageList]);
    // useEffect(() => {
    //     if (!selectedMailItem && currentMailMessageList.length > 0) {
    //         setSelectedMailItem(currentMailMessageList[0]);
    //     }
    // }, [selectedMailItem]);

    const rightSideUi = (isDrawer = false) => {
        // let record = selectedMailItem ? selectedMailItem : currentMailMessageList.length > 0 ? currentMailMessageList[0] : '';
        return (
            <MailMessageDetails
                isDrawer={isDrawer}
                selectedMailItem={selectedMailItem}
                updateAllMail={updateAllMail}
                handleSnoozed={handleSnoozed}
                handleDelete={handleDelete}
                handleStarred={handleStarred}
                handlePrint={handlePrint}
            />
        );
    };

    const getReadCount = (cMailNav) => {
        let records = mailMessageAllDataList?.filter((cItem) => {
            return cMailNav.filter(cItem) && !cItem.read;
        });
        return records.length;
    };

    const getNevList = () => {
        if (userDetails?.contact?.hasRAService) {
            return MAIL_NAV_LIST;
        }
        return MAIL_NAV_LIST.filter((item) => item.id !== '1');
    };

    return (
        <>
            <MailMessagesListBox>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} marginBottom={'1rem'}>
                    <Typography component={'h1'} variant="heading1" color={'text.primary'} fontFamily={'fontFamilyCondensed'}>
                        Mailbox
                    </Typography>
                    <FilterByCompany hideHousehold={true} selectedCompanyList={selectedCompanyList} onChange={handleCompanyFilterChange} />
                </Box>
                <ParaText marginTop={theme.typography.generic.xSmall}>Keep track of everything PRIME sends you, from updates to important alerts.</ParaText>

                <ListStyled>
                    {getNevList().map((cMailNav) => {
                        return (
                            <MailNavListItem key={cMailNav.id}>
                                <MailNavListItemButton
                                    onClick={() => {
                                        handleNavSelection(cMailNav);
                                    }}
                                    sx={{
                                        '& .MuiChip-root': {
                                            background: theme.palette.brandPrimary[900],
                                            color: theme.palette.white[1000],
                                        },

                                        ...(cMailNav?.id === selectedNavItem?.id && {
                                            borderBottom: `1px solid ${theme.palette.border.brandPrimary}`,
                                            // borderRadius: theme.typography.borderRadius.xxxSmall,

                                            '& .icon': {
                                                color: theme.palette.primary.main,
                                            },
                                            '& .text.MuiTypography-root': {
                                                color: theme.palette.primary.main,
                                            },
                                            '& .MuiChip-root': {
                                                background: theme.palette.primary.main,
                                                color: theme.palette.white[1000],
                                            },
                                        }),
                                    }}
                                >
                                    <Typography
                                        component={'span'}
                                        variant="paraText2"
                                        color={'text.primary'}
                                        className="text"
                                        sx={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {cMailNav.label}
                                    </Typography>
                                    {getReadCount(cMailNav) > 0 && (
                                        <CustomChip
                                            label={getReadCount(cMailNav)}
                                            sx={{
                                                padding: `${theme.typography.generic.none} ${theme.typography.generic.xxxxSmall}`,
                                                fontSize: theme.typography.customFontSize.small,
                                                minWidth: '2rem',
                                                marginLeft: '0.5rem',
                                            }}
                                        />
                                    )}
                                </MailNavListItemButton>
                            </MailNavListItem>
                        );
                    })}
                </ListStyled>

                {/* <Divider
                    sx={{
                        margin: `${theme.typography.generic.xLarge} ${theme.typography.generic.none}`,
                    }}
                /> */}

                {selectedCompanyList.length > 0 ? (
                    <ShowAddedCompanyBox
                        selectedCompanyList={selectedCompanyList}
                        sx={{
                            marginTop: `${theme.typography.generic.xLarge}`,
                        }}
                    />
                ) : (
                    <Box margin={`${theme.typography.generic.small} ${theme.typography.generic.none}`}></Box>
                )}
                <MailMessagesList>
                    {currentMailMessageList.length === 0 && (
                        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <NoDataPresentUI
                                containerSx={{
                                    width: {
                                        xs: '100%',
                                        sm: '100%',
                                        md: '60%',
                                    },
                                    // gap:"0"
                                }}
                                heading="Looks like you don’t have any messages!"
                                icon={<Box component={'img'} src="/images/other/cropped_no_mail.png" alt="No mails found" sx={{ width: '100px', height: '100px' }} />}
                            />
                        </Box>
                    )}
                    {currentMailMessageList.map((cListItem) => (
                        <MailMessageListItem key={cListItem.id}>
                            <MailMessageListItemButton
                                disableRipple
                                onClick={() => {
                                    handleMailListSelection(cListItem);
                                }}
                                className={selectedMailItem?.id === cListItem.id ? 'active' : ''}
                            >
                                <MailMessageListItemTextBox>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography
                                            component="h2"
                                            variant="paraText2"
                                            color={'text.primary'}
                                            sx={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                marginBottom: `${theme.typography.generic.xxxSmall}`,
                                                display: 'flex',
                                                justifyContent: 'start',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {!cListItem.read && (
                                                <Box
                                                    component={'div'}
                                                    sx={{
                                                        display: 'inline-block',
                                                        width: '6px',
                                                        height: '6px',
                                                        background: '#0255fc',
                                                        borderRadius: theme.typography.borderRadius.round,
                                                        marginRight: theme.typography.generic.xxSmall,
                                                    }}
                                                ></Box>
                                            )}
                                            {cListItem.lastModifiedByName === 'PRIME Relay Admin' ? 'PRIME Support' : cListItem.lastModifiedByName}
                                        </Typography>
                                        <Box display={'flex'} position={'relative'}>
                                            {cListItem.hasFile && (
                                                <IconButton
                                                    sx={{
                                                        padding: 0,
                                                        margin: 0,
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        marginRight: '0.5rem',

                                                        '& svg': {
                                                            margin: 0,
                                                            transform: 'rotate(218deg)',
                                                        },
                                                    }}
                                                >
                                                    <AttachFile />
                                                </IconButton>
                                            )}

                                            <Typography component={'span'} variant="paraText6" color={'text.secondary'}>
                                                {format(new Date(cListItem.lastModifiedDate), 'MM/dd/yyyy')}
                                            </Typography>
                                            <Typography
                                                component={'span'}
                                                variant="paraText6"
                                                color={'text.secondary'}
                                                sx={{
                                                    position: 'absolute',
                                                    top: '16px',
                                                    right: '0px',
                                                }}
                                            >
                                                {format(new Date(cListItem.lastModifiedDate), 'hh:mm a')}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Typography
                                        component={'p'}
                                        variant="paraText4"
                                        color={'text.secondary'}
                                        sx={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box', // Required for line clamping
                                            WebkitBoxOrient: 'vertical', // Required for line clamping
                                            WebkitLineClamp: 2, // Limits to 3 lines before truncating
                                            marginBottom: `${theme.typography.generic.xSmall}`,
                                        }}
                                    >
                                        {cListItem.subject}
                                    </Typography>
                                    <Box display={'flex'} gap={'0.5rem'} flexWrap={'wrap'}>
                                        <CompanyBadge accountId={cListItem.companyId} accountName={cListItem.companyName} isLink openInNewTab></CompanyBadge>
                                    </Box>
                                </MailMessageListItemTextBox>
                            </MailMessageListItemButton>
                        </MailMessageListItem>
                    ))}
                </MailMessagesList>
            </MailMessagesListBox>

            {isMobileView ? (
                <Drawer
                    open={open}
                    onClose={() => toggleDrawer(false)}
                    anchor="right"
                    PaperProps={{
                        sx: {
                            width: '100%',
                        },
                    }}
                >
                    <DrawerHeaderBox
                        handleBack={handleBack}
                        heading={selectedMailItem?.heading}
                        textBoxSx={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    />

                    <Box height={`calc(100% - ${'4.6rem'})`} overflow={'auto'}>
                        {rightSideUi(true)}
                    </Box>
                </Drawer>
            ) : (
                rightSideUi()
            )}
        </>
    );
}

export default MailMessagesListBoxUI;
